<template>
  <div class="flex justify-center">
    <div class="m-4 md:w-3/5 w-full">
      <h1 class="font-bold text-5xl mb-4 flex justify-around">
        <span class="block border-b-8 border-gray-300">
          <span class="block -mb-8">Log In</span>
        </span>
      </h1>
      <h2 class="mb-8 text-center">
        or
        <nuxt-link class="font-bold text-orange-400" :to="{ name: 'register' }">
          Create Account
        </nuxt-link>
      </h2>
      <login-form @loggedIn="loggedIn()" />
    </div>
  </div>
</template>

<script>
import LoginForm from '~/components/LoginForm.vue'

export default {
  head() {
    return {
      title: 'Log In - Indie Film Lab'
    }
  },
  middleware: ['guest'],
  auth: 'guest',
  components: {
    LoginForm
  },
  methods: {
    loggedIn() {
      this.$router.push({
        name: 'cart'
      })
    }
  }
}
</script>
